export const showTopNotification = (message, duration = 3000) => {
    const existing = document.getElementById("top-notification");
    if (existing) existing.remove();

    const modeBtn = document.querySelector(".custom-toggle-btn");
    const headerInfo = document.querySelector(
        ".stage-header_stage-menu-wrapper_oLSb9",
    );

    const container = headerInfo || document.body;

    const notification = document.createElement("div");
    notification.id = "top-notification";
    notification.innerHTML = `
        <div class="top-notification-content">
            <span class="notification-text">${message}</span>
            <button class="notification-close" aria-label="Cerrar">×</button>
        </div>
    `;

    Object.assign(notification.style, {
        position: "absolute",
        top: "100%",
        left: "50%",
        transform: "translateX(-50%) translateY(-10px)",
        zIndex: "10002",
        opacity: "0",
        animation: `slideDown 0.4s ease forwards`,
    });

    const styles = document.createElement("style");
    styles.textContent = `
        @keyframes slideDown {
            from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
            to { opacity: 1; transform: translateX(-50%) translateY(4px); }
        }
        @keyframes fadeOut {
            to { opacity: 0; transform: translateX(-50%) translateY(-10px); }
        }
        .top-notification-content {
            background: #4d97ff;
            color: white;
            padding: 10px 20px;
            border-radius: 8px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.2);
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 13px;
            font-weight: 600;
            white-space: nowrap;
            text-align: center;
        }
        .notification-close {
            position: absolute;
            top: 2px;
            right: 4px;
            background: rgba(255,255,255,0.2);
            border: none;
            color: rgba(255,255,255,0.7);
            font-size: 11px;
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 50%;
            cursor: pointer;
            padding: 0;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: color 0.2s ease;
        }
        .notification-close:hover {
            color: white;
        }
    `;

    document.head.appendChild(styles);
    if (getComputedStyle(container).position === "static")
        container.style.position = "relative";
    container.appendChild(notification);

    const closeBtn = notification.querySelector(".notification-close");
    closeBtn.addEventListener("click", () => {
        notification.style.animation = "fadeOut 0.3s ease forwards";
        setTimeout(() => notification.remove(), 300);
    });
};
